import * as pdfjsLib from "pdfjs-dist";
import pdfjsWorker from "pdfjs-dist/build/pdf.worker.mjs?url";

if (typeof window !== "undefined") {
  pdfjsLib.GlobalWorkerOptions.workerSrc = pdfjsWorker;
}

/**
 * Returns true only when the PDF cannot be opened without a user password.
 * Permission-only / owner-restriction encryption (empty user password) returns false.
 */
export async function pdfRequiresOpenPassword(
  data: ArrayBuffer
): Promise<boolean> {
  const uint8 = new Uint8Array(data);
  const loadingTask = pdfjsLib.getDocument({
    data: uint8,
    password: "",
  });
  try {
    const doc = await loadingTask.promise;
    await doc.destroy();
    return false;
  } catch (e: unknown) {
    const ex = e as { name?: string; code?: number };
    if (
      ex.name === "PasswordException" &&
      (ex.code === pdfjsLib.PasswordResponses.NEED_PASSWORD ||
        ex.code === pdfjsLib.PasswordResponses.INCORRECT_PASSWORD)
    ) {
      return true;
    }
    return false;
  }
}
